module.exports = __webpack_public_path__ + "sk-trip-wizard-mockup.3n-USWjg.png";